import { render, staticRenderFns } from "./OleMissBuffersReportSheet.vue?vue&type=template&id=72082353&"
import script from "./OleMissBuffersReportSheet.vue?vue&type=script&lang=js&"
export * from "./OleMissBuffersReportSheet.vue?vue&type=script&lang=js&"
import style0 from "./OleMissBuffersReportSheet.vue?vue&type=style&index=0&id=72082353&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VRadio,VRadioGroup,VSimpleTable})
